export default {
  SELECTION: 1,
  TEXT: 2,
  DATE_RANGE: 3,
  CURRENCY: 4,
  NUMBER: 5,
  BOOL: 6,
  TIME: 7,
};
